<template>
  <div class="ach-box">
    <div class="ach-top-team ach-top-col">
      <div class="ach-tit">团队业绩</div>
      <div class="ach-item-money">业绩总额：<span class="num-color">{{ achievement.teamAllMoney }}</span> 元</div>
      <div class="ach-item-money">苹果系统业绩额：<span class="num-color-2">{{ achievement.teamIosMoney }}</span> 元</div>
      <div class="ach-item-money">安卓系统业绩额：<span class="num-color-2">{{ achievement.teamAndroidMoney }}</span> 元</div>
      <div class="ach-item-team">业务员总数：<span class="num-color">{{ achievement.teamSalesmanNum }}</span> 人</div>
      <div class="ach-item-team">用户总数：<span class="num-color">{{ achievement.teamUserNum }}</span> 人</div>
    </div>
<!--    <div class="ach-bottom-team ach-bottom-col">-->
<!--      <div class="ach-tit">育成团队业绩</div>-->
<!--      <div class="ach-item-money">业绩总额：<span class="num-color">{{ achievement.fosterAllMoney }}</span> 元</div>-->
<!--      <div class="ach-item-money">苹果系统业绩额：<span class="num-color-2">{{ achievement.fosterIosMoney }}</span> 元</div>-->
<!--      <div class="ach-item-money">安卓系统业绩额：<span class="num-color-2">{{ achievement.fosterAndroidMoney }}</span> 元</div>-->
<!--      <div class="ach-item-team">育成团队长总数：<span class="num-color">{{ achievement.fosterNum }}</span> 人</div>-->
<!--      <div class="ach-item-team">业务员总数：<span class="num-color">{{ achievement.fosterSalesmanNum }}</span> 人</div>-->
<!--      <div class="ach-item-team">用户总数：<span class="num-color">{{ achievement.fosterUserNum }}</span> 人</div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'AchievementInfo',
  data () {
    return {
    }
  },
  props: {
    // 业绩信息
    'achievement': {
      type: Object,
      default: {
        fosterAllMoney: 0,
        fosterIosMoney: 0,
        fosterAndroidMoney: 0,
        fosterNum: 0,
        fosterSalesmanNum: 0,
        fosterUserNum: 0,
        teamAllMoney: 0,
        teamIosMoney: 0,
        teamAndroidMoney: 0,
        teamSalesmanNum: 0,
        teamUserNum: 0
      }
    },
    'teamName': {
      type: String,
      default: ''
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style>
.ach-box {
  margin-bottom: 20px;
  border: 1px solid #dedede;
  border-radius: 5px;
}
.ach-top-team {
  border-bottom: 1px solid #dedede;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.ach-bottom-team {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.ach-item-team {
  text-align: center;
  padding: 30px 0 30px 0;
  font-weight: bold;
  font-size: 18px;
}
.ach-item-money {
  width: 30%;
  text-align: center;
  padding: 30px 0 0 0;
  font-weight: bold;
  font-size: 18px;
}
.num-color {
  color: #ff4d51;
}
.num-color-2 {
  color: #ff7900;
}
.ach-top-col {
  color: #3a8ee6;
}
.ach-bottom-col {
  color: #67C23A;
}
.ach-tit {
  width: 100%;
  padding: 20px 0 0 0;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/salesman/AchievementInfo.vue